import { isChannelMobileApp } from '@chewy/request-utils';
import { sendGTMEvent } from '@next/third-parties/google';

import { PageType } from '../constants';

import { ANALYTICS_TAG, useAnalyticsContext } from '@/components/Analytics/AnalyticsProvider';

export const useChat = (pageType?: PageType) => {
  const { getEventCategory, track } = useAnalyticsContext();

  const handleChatClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const eventCategory = getEventCategory(pageType);
    if (eventCategory) {
      track(ANALYTICS_TAG.NAME_BUTTON_CLICKED, {
        eventCategory,
        eventAction: ANALYTICS_TAG.EVENT_CLICK,
        eventLabel: 'get-real-chat-now',
      });

      sendGTMEvent({
        event: ANALYTICS_TAG.NAME_BUTTON_CLICKED,
        eventCategory,
        eventAction: ANALYTICS_TAG.EVENT_CLICK,
        eventLabel: 'get-real-chat-now',
      });
    }

    const isMobileApp = isChannelMobileApp(window.navigator.userAgent);

    if (isMobileApp) return;

    e.preventDefault();

    window?.dispatchEvent(new Event('chatToggle'));
  };

  return { handleChatClick };
};
